module.exports = __webpack_public_path__ + "src/assets/images/sd_one_blau.svg";